import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import { Button } from 'sarsaparilla';
import ImageEdit from "../../containers/StewardAssetEditPage/ImageEdit";
import { ImageDefaults, ImageProps } from "../../props/image";

import pageStyles from "../../containers/StewardAssetEditPage/StewardAssetEditPage.scss";

const propTypes = {
  mediaType: PropTypes.string,
  value: PropTypes.shape({
    media: PropTypes.arrayOf(ImageProps)
  })
};

const defaultProps = {
  value: []
};

export default class ImagesTab extends PureComponent {
  constructor(props) {
    super(props);


    this.state = {
      media: this.props.value.media
    };

    this.addMedia = this.addMedia.bind(this);
    this.removeMedia = this.removeMedia.bind(this);
  }

  addMedia() {
    const media = { ...ImageDefaults, _key: uniqueId('media-') };

    this.setState((prevState) => ({ ...prevState, media: [...prevState.media, media] }));
  }

  removeMedia(key) {
    this.setState((prevState) => ({
      ...prevState,
      media: prevState.media.filter((media) => media._key !== key)
    }));
  }

  render() {
    const { mediaType } = this.props;
    const { media: images } = this.state;

    return (
      <div className={pageStyles["tab-body"]}>
        {images.map((image) => (
          <ImageEdit
            key={image._key}
            value={image}
            mediaType={mediaType}
            onRemove={this.removeMedia} />
        ))}
        <Button onClick={this.addMedia}>
          Add Image
        </Button>
      </div>
    );
  }
}

ImagesTab.propTypes = propTypes;
ImagesTab.defaultProps = defaultProps;
